function SobreNosotros() {
    return (
        <>
        <div className="App d-flex justify-content-center bg-dark text-white">
                <div className="col-8 bg-dark text-white justificado my-4 mb-4">
                <h1>¿Quiénes somos?</h1>
                <p>Somos Diego y Santiago, un par de estudiantes de la UCM que necesitan hacer un TFG.</p>
                <br/>
                <h1>Motivaciones</h1>
                <p>Hoy en día estamos acostumbrados a difundir constantemente información de qué hacemos 🎆, qué comemos 🌮, con quién estamos 👨‍👩‍👧‍👦... En un principio no es nada malo, pero cuando salimos de viaje puede ser un tema delicado, ya que anunciamos que nuestra casa 🏡 se encuentra desprotegida dando lugar a que ladrones 🦝, okupas o gente no deseada aproveche la ocasión.</p>
                <br/>
                <p>Por eso nos hemos planteado la creación de esta red social, que permite un abanico de opciones para la privacidad 🕵🏻‍♀️.</p>
                <br/>
                <h1>Aspiraciones</h1>
                <p>Nuestro principal objetivo es concienciar del uso responsable de las redes sociales, ya que muchas veces no somos conscientes de toda la información que divulgamos y las consecuencias que esto puede tener.</p>
                </div>
            </div>
            <title>Sobre nosotros</title>
        </>
    );
}



export default SobreNosotros;